import React from 'react';

const NavLink = ({ href, children, external }) => {
  const extra = external
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};

  return (
    <a
      href={href}
      {...extra}
      className="link-accent text-sm text-muted hover:text-ink"
    >
      {children}
    </a>
  );
};

const Sidebar = () => {
  return (
    <header className="sticky top-0 z-20 bg-paper/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-site items-center justify-between gap-4 px-5 py-4 sm:px-8">
        <a
          href="#top"
          className="font-display text-base font-bold tracking-tight text-ink"
        >
          ZK
        </a>
        <nav aria-label="Primary" className="flex flex-wrap items-center justify-end gap-x-5 gap-y-1">
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#education">Education</NavLink>
          <NavLink href="/Zachary_Klein_Resume.pdf" external>Resume</NavLink>
          <NavLink href="https://linkedin.com/in/zachkklein" external>LinkedIn</NavLink>
          <NavLink href="https://github.com/zachkklein" external>GitHub</NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Sidebar;
